import { render, staticRenderFns } from "./InfoRGPD.vue?vue&type=template&id=1704ccc9"
import script from "./InfoRGPD.vue?vue&type=script&lang=js"
export * from "./InfoRGPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports